module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-just-play.c2f5a1ee.png";